const countryCodes = {
  da: 'da',
  en: 'en',
}
export default countryCodes
